@if (!noPropertiesFound) {
<div class="user-property-heading-row">
  <div>
    <h3>Your Managed Properties</h3>
  </div>
  <div *ngIf="!isLoading">
    <button mat-flat-button class="metallic-text-btn-blue" type="button" (click)="createProperty()">
      <mat-icon matPrefix>add</mat-icon>
      Add New Property
    </button>
  </div>
</div>
<div class="user-property-list-table-container">
  <div class="mat-elevation-z8 hide-on-mobile">
    <mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="displayName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Display Name </mat-header-cell>
        <mat-cell *matCellDef="let property">
          <div *ngIf="isLoading" class="skeleton-loader"></div>
          <span *ngIf="!isLoading">{{ property.displayName ?? '' }}</span>
        </mat-cell>
      </ng-container>


      <ng-container matColumnDef="image">
        <mat-header-cell *matHeaderCellDef>Featured Image</mat-header-cell>
        <mat-cell *matCellDef="let property">
          <div *ngIf="isLoading" class="skeleton-loader"></div>
          <img [src]="property.primaryImageUrl" style="height: 40px; border-radius: 12px; max-width: 40px;" alt="property main image"/>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="location">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Location </mat-header-cell>
        <mat-cell *matCellDef="let property">
          <div *ngIf="isLoading" class="skeleton-loader"></div>
          <span *ngIf="!isLoading">{{ property.address.city ?? '' }}, {{ property.address.state }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="zipCode">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Zip Code </mat-header-cell>
        <mat-cell *matCellDef="let property">
          <div *ngIf="isLoading" class="skeleton-loader"></div>
          <span *ngIf="!isLoading">{{ property.address.zipCode ?? '' }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="saveCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Saves </mat-header-cell>
        <mat-cell *matCellDef="let property">
          <div *ngIf="isLoading" class="skeleton-loader"></div>
          <span *ngIf="!isLoading">{{ property.saveCount }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="isPublished">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Published</mat-header-cell>
        <mat-cell *matCellDef="let property">
          <div *ngIf="isLoading" class="skeleton-loader skeleton-circle"></div>
          <ng-container *ngIf="!isLoading">
            <mat-icon [class.success]="property.isPublished" [class.error]="!property.isPublished">
              {{ property.isPublished ? 'check_circle' : 'cancel' }}
            </mat-icon>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
        <mat-cell *matCellDef="let property">
          <ng-container *ngIf="isLoading">
            <div class="skeleton-loader skeleton-circle"></div>
          </ng-container>

          <ng-container *ngIf="!isLoading">
            <button mat-icon-button [matMenuTriggerFor]="propertyMenu" aria-label="Property actions">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #propertyMenu="matMenu" xPosition="before" class="nav-user-menu">
              @if(!property.isPublished) {
                <button mat-menu-item (click)="publishProperty(property.id)"><mat-icon color="primary">public</mat-icon><span>Publish Property</span></button>
              }
              <button mat-menu-item (click)="editPricing(property)">
                <mat-icon color="primary">price_change</mat-icon>
                <span>Manage Pricing</span>
              </button>

              <button mat-menu-item (click)="manageBooking(property)">
                <mat-icon color="primary">edit_calendar</mat-icon>
                <span>Manage Calendar</span>
              </button>

              <button mat-menu-item [routerLink]="['/property', property.id, 'edit']">
                <mat-icon color="primary">edit</mat-icon>
                <span>Edit Property</span>
              </button>

              <button mat-menu-item (click)="openImageGenerator(property)" *ngIf="property.isPublished">
                <mat-icon color="primary">image</mat-icon>
                <span>Image Generator</span>
              </button>

              <button mat-menu-item (click)="openQrCode(property.id)" *ngIf="property.isPublished">
                <mat-icon color="primary">qr_code</mat-icon>
                <span>Generate QR Code</span>
              </button>

              <button mat-menu-item (click)="cancelSubscription(property.id)">
                <mat-icon color="primary">public_off</mat-icon>
                <span>Cancel Listing</span>
              </button>

              <mat-divider *ngIf="property.isPublished"></mat-divider>

              <button mat-menu-item (click)="viewProperty(property)" *ngIf="property.isPublished">
                <mat-icon color="primary">preview</mat-icon>
                <span>View Listing</span>
              </button>
            </mat-menu>
          </ng-container>
        </mat-cell>
      </ng-container>


      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>

  <div class="mobile-property-list show-on-mobile" *ngIf="!isLoading">
    <mat-card *ngFor="let property of dataSource.connect() | async" class="mobile-property-card">
      <mat-card-header>
        <div mat-card-avatar>          
          <mat-icon [class.success]="property.isPublished" [class.error]="!property.isPublished">
            {{ property.isPublished ? 'check_circle' : 'cancel' }}
          </mat-icon>
          <img [src]="property.primaryImageUrl" style="height: 40px; border-radius: 12px; max-width: 40px;" alt="property image" />
        </div>
        <mat-card-title>{{ property.displayName }}
          <div class="icon-container">
            <mat-icon>favorite</mat-icon>
            <span class="icon-number">{{ property.saveCount }}</span>
          </div>
        </mat-card-title>
        <mat-card-subtitle>{{ property.address.city }}, {{ property.address.state }} {{ property.address.zipCode
          }}</mat-card-subtitle>
      </mat-card-header>

      <mat-card-actions>
        @if(!property.isPublished) {
          <button mat-icon-button (click)="publishProperty(property.id)"><mat-icon>public</mat-icon></button>
        }
        <button mat-icon-button (click)="editPricing(property)"><mat-icon>price_change</mat-icon></button>
        <button mat-icon-button (click)="manageBooking(property)"><mat-icon>edit_calendar</mat-icon></button>
        <button mat-icon-button [routerLink]="['/property', property.id, 'edit']"><mat-icon>edit</mat-icon></button>
        @if(property.isPublished) {
          <button mat-icon-button (click)="openQrCode(property.id)"><mat-icon>qr_code</mat-icon></button>
          <button mat-icon-button (click)="openImageGenerator(property)"><mat-icon>image</mat-icon></button>
          <button mat-icon-button (click)="cancelSubscription(property.id)"><mat-icon>public_off</mat-icon></button>
          <button mat-icon-button (click)="viewProperty(property)"><mat-icon>preview</mat-icon></button>
        }
      </mat-card-actions>
    </mat-card>
  </div>

  <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25, 50, 100]" aria-label="Select page of properties">
  </mat-paginator>
</div>
} @else {
<div class="managed-properties-empty-state">
  <div class="hero-container">

    <header class="hero-header">
      <div class="icon-orb">
        <i class="fa-duotone fa-solid fa-house-medical-flag"></i>
      </div>
      <h2>Ready to Put Your Property on the Map?</h2>
      <p class="description">
        It looks like you haven't added any listings to Horizinns... yet 😉
      </p>
    </header>

    <div class="content-grid">
      <mat-card class="info-card info-card-blue">
        <mat-card-header>
          <mat-card-title>
            <i class="fa-solid fa-hand-holding-dollar"></i> More Control. Less Cost.
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="promo-highlight">Host for just <strong>$300/year</strong> and keep <strong>100%</strong> of your
            rental income.</p>
          <ul class="benefit-list">
            <li>
              <i class="fa-solid fa-circle-check"></i>
              <span><strong>Zero fees per booking</strong> — keep every cent</span>
            </li>
            <li>
              <i class="fa-solid fa-circle-check"></i>
              <span><strong>Total Control</strong> — update pricing and calendars in real-time</span>
            </li>
            <li>
              <i class="fa-solid fa-circle-check"></i>
              <span><strong>Direct Access</strong> — communicate directly with renters, no middleman</span>
            </li>
          </ul>
        </mat-card-content>
      </mat-card>

      <mat-card class="info-card comparison-card">
        <mat-card-header>
          <mat-card-title>Compare the Difference</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <table class="minimal-table">
            <thead>
              <tr>
                <th>Feature</th>
                <th>Others</th>
                <th class="brand-text">Horizinns</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Host Fee</td>
                <td>3-15%</td>
                <td class="brand-text">$300/yr</td>
              </tr>
              <tr>
                <td>Profit</td>
                <td>Reduced</td>
                <td class="brand-text">100%</td>
              </tr>
              <tr>
                <td>Control</td>
                <td>Limited</td>
                <td class="brand-text">Full</td>
              </tr>
            </tbody>
          </table>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="cta-section">
      <button mat-fab extended color="primary" routerLink="/property/create" class="main-cta">
        <mat-icon>add</mat-icon>
        LIST YOUR FIRST PROPERTY
      </button>
      <p class="footer-note">Perfect for individual homeowners or professional managers.</p>
    </div>

  </div>
</div>
}